import 'app/agriculture/components/Card/Card.scss';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface CardProps {
    className?: string;
    children: ReactNode;
}

export function Card({ className, children }: CardProps) {
    return <div className={classNames('Card', className)}>{children}</div>;
}
